import { useState } from 'react';

import { ABOUT, ABOUT_PHOTO } from '../content/about';
import { useSeo } from '../lib/head';
import { Link } from '../lib/router';
import { aboutMeta } from '../lib/seo';
import { useStore } from '../lib/store';

export function About() {
  const { lang, t } = useStore();
  useSeo(aboutMeta(lang));
  const content = ABOUT[lang];
  // Пока фото не загружено, блок не показываем, а не рисуем битую картинку
  const [photoOk, setPhotoOk] = useState(true);

  return (
    <div className="wrap page about">
      <span className="hand" style={{ fontSize: '1.5rem' }}>
        {t.tagline}
      </span>
      <h1 style={{ marginTop: '0.5rem' }}>{content.title}</h1>

      <div className={photoOk ? 'about__body about__body--photo' : 'about__body'}>
        {photoOk && (
          <img
            className="about__photo"
            src={ABOUT_PHOTO}
            alt={content.photoAlt}
            onError={() => setPhotoOk(false)}
          />
        )}
        <div>
          <p className="lede">{content.lede}</p>
          {content.paragraphs.map((paragraph, index) => (
            <p key={index} style={{ maxWidth: '62ch' }}>
              {paragraph}
            </p>
          ))}
        </div>
      </div>

      <Link to="/" className="btn btn--ghost" style={{ marginTop: '2rem' }}>
        {t.goShopping}
      </Link>
    </div>
  );
}
